export const authenticationMarkdown = `# Authentication

CimmplePay API uses JWT bearer tokens for authenticated endpoints.

## Login flow

Use:

- \`POST /api/auth/login\`

Example request:

\`\`\`json
{
  "username": "api.user@example.com",
  "password": "your-password"
}
\`\`\`

Example response (simplified):

\`\`\`json
{
  "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
  "user": {
    "id": 10,
    "username": "api.user@example.com",
    "role": "Admin",
    "companyId": 5
  },
  "companies": [
    {
      "id": 5,
      "name": "Acme Inc"
    }
  ]
}
\`\`\`

## Using the token

Send token in the header:

\`\`\`http
Authorization: Bearer {token}
\`\`\`

## Company context

If a user has access to multiple companies, integration can switch context using:

- \`POST /api/auth/switch-company\`

Body:

\`\`\`json
{
  "companyId": 5
}
\`\`\`

Use the returned token for all company-scoped requests.

## Common auth endpoints

- \`POST /api/auth/login\`
- \`GET /api/auth/me\`
- \`GET /api/auth/companies\`
- \`POST /api/auth/switch-company\`
- \`POST /api/auth/change-password\`

## Error handling guidance

- \`401 Unauthorized\`: invalid or expired token
- \`403 Forbidden\`: authenticated but no access to resource
- \`400 Bad Request\`: invalid request format/required fields missing

## Security guidance for partners

- store access tokens securely; never log full token values
- use short-lived in-memory token cache when possible
- rotate integration credentials on a policy schedule
- always use TLS (HTTPS) in transit
`;
